import { Component, Input, OnInit, OnChanges, ViewChild, ElementRef, ViewEncapsulation, OnDestroy } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService, CalculationService, ValidationService } from 'app/services';
import { config, messages } from 'app/constants';
import { find, debounce } from 'lodash';
import { newSupplier, phoneTypes, contact } from 'app/constants/supplier';
import { setData } from '@progress/kendo-angular-intl';
import { Subscription } from 'rxjs';
import { sortBy } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-supplier-add',
  templateUrl: './supplier-add.component.html',
  styleUrls: ['./supplier-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierAddComponent implements OnInit, OnDestroy {
  supplier = this.helperService.deepCopy(newSupplier);
  @ViewChild('addCustomerForm', { static: true }) addCustomerForm: ElementRef;
  phoneTypes = phoneTypes;
  isEmailDisabled: boolean = true;
  isPhoneDisabled: boolean = true;
  contactOnEmail = false;
  contactOnPhone = false;
  isZipCode1Valid: boolean = true;
  isZipCode2Valid: boolean = true;
  addressCityResults: any[] = [];
  bAddressCityResults: any[] = [];
  addressCities: any[] = [];
  bAddressCities: any[] = [];
  allCities: any[] = [];
  supplierTags: any[] = [];
  tagTypeSupplier: string = this.helperService.deepCopy(config.tags.supplier);
  isProcessing: boolean = false;
  errors = {
    emails: {},
    phones: {},
  };
  isSupplierDataValid: boolean = true;
  supplierTypes: any[] = [
    {
      label: 'Internal',
      name: 'Internal',
      value: 'internal',
      icon: 'far fa-user',
      placeholder: 'Internal',
    },
    {
      label: 'Online ordering',
      name: 'Online ordering',
      value: 'online',
      icon: 'far fa-cars',
      placeholder: 'Online ordering',
    }
  ];
  validate: any = {};
  supplierId: any = '';
  primaryEmail: string = '';
  emails;
  isValidUrl = true;
  subscription: Subscription;
  isAccountPayablePayment: boolean = false;
  paymentTerms = [];
  isSubletSupplierType: boolean = false;
  qboSupplierList: any = [];
  internalSuppliersResults: any;
  selectedSupplierName: string = '';
  focus: any = {};

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private calculationService: CalculationService,
    private dataService: DataService,
    private dialogService: DialogService,
    private validationService: ValidationService,
    private dynamicDialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit() {
    const { supplierId, data, isSubletSupplierType } = this.dynamicDialogConfig.data;
    this.supplierId = supplierId;
    this.isSubletSupplierType = isSubletSupplierType;
    if(this.isSubletSupplierType) {
      this.getQboSupplierList();
    }
    this.setData();
    if (this.supplierId) {
      this.getSuppliers();
    }
    // this.fetchsupplierTags();
  }

  setData() {
    this.subscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isAccountPayablePayment = this.dataService.accountPayablePayment;
          this.paymentTerms = this.dataService.accPayableTerms;
          //this.subscription.unsubscribe();
        }
      }
    });
    this.paymentTerms = this.dataService.accPayableTerms;
    if (this.paymentTerms.length) {
      this.paymentTerms.map((res) => {
        res.label = res.name;
        res.value = res._id;
      });
    }
    this.isAccountPayablePayment = this.dataService.accountPayablePayment;
  }

  getSuppliers() {
    this.httpService
      .getSupplierById(this.supplierId)
      .then(
        (data: any) => {
          if (data) {
            // data && !data.type ? (data.type = 'internal') : null;
            this.supplier = data;
            this.supplier.accPayableTerm = data.accPayableTerm;
            if (this.supplier.type === 'internal') {
              this.supplier.type = this.supplierTypes[0];
            } else if (this.supplier.type === 'online') {
              this.supplier.type = this.supplierTypes[1];
            }
            this.supplier.phones = [];
            this.supplier.emails = [];

            data.contactId.contactInfo.forEach((contactInfo: any) => {
              const contact = { ...contactInfo };

              if (contact.contactType === 'email') {
                contact.contactType = {
                  label: 'Email',
                  value: 'email',
                };
                if (contact.isPrimary) {
                  contact.value = contactInfo.value;
                }

                this.supplier.emails.push(contact);
              } else {
                contact.contactType = find(this.phoneTypes, {
                  value: contact.contactType,
                });

                if (contact.isPrimary) {
                  contact.value = this.helperService.removePhoneFormatting(contactInfo.value);
                }

                this.supplier['phones'].push(contact);
              }
            });
            if (data.contactId.contactInfo.length === 0) {
              (data.contactId.contactInfo.emails = [
                {
                  ...contact,
                  isPrimary: true,
                  contactType: { label: 'Email', value: 'email' },
                },
              ]),
                (data.contactId.contactInfo.phones = [
                  {
                    ...contact,
                    isPrimary: true,
                    contactType: { label: 'Mobile', value: 'mobile' },
                  },
                ]);
              (this.supplier['emails'] = [
                {
                  ...contact,
                  isPrimary: true,
                  contactType: { label: 'Email', value: 'email' },
                },
              ]),
                (this.supplier['phones'] = [
                  {
                    ...contact,
                    isPrimary: true,
                    contactType: { label: 'Mobile', value: 'mobile' },
                  },
                ]);
            }

            if (!data.billingAddress) {
              this.supplier.billingAddress = {
                addLine1: '',
                addLine2: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                stateCode: '',
              };
            }

            if (!data.wareHouseAddress) {
              this.supplier.wareHouseAddress = {
                addLine1: '',
                addLine2: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                stateCode: '',
              };
            }
          }
          // this.supplier.type = this.supplierTypes[0];
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      )
      .finally(() => {
        // this.isLoading = false;
      });
  }

  fetchsupplierTags() {
    this.httpService.getTags(config.tags.supplier).then(
      (tags: any[]) => {
        this.supplierTags = tags;
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    );
  }

  handleChange(type: string, event: any) {
    if (type === 'url' && event === '') {
      this.isValidUrl = true;
    }
    if (type === 'type') {
      if (event === 'online') {
        return;
      } else {
        this.supplier.type = this.supplierTypes[0];
        // this.supplier[type] = event;
      }
    }
    if (type === 'supplierName') {
      this.supplier.name = event;
    }

    if (type === 'phone' || type === 'phone2') {
      this.supplier[type] = this.helperService.removePhoneFormatting(event);
    } else if (type === 'wareHouseAddress-addLine1') {
      this.supplier.wareHouseAddress.addLine1 = event;
    } else if (type === 'billingAddress-addLine1') {
      this.supplier.billingAddress.addLine1 = event;
    } else if (type === 'wareHouseAddress-zip') {
      this.isZipCode1Valid = true;
      this.supplier.wareHouseAddress.zip = event;
    } else if (type === 'billingAddress-zip') {
      this.isZipCode2Valid = true;
      this.supplier.billingAddress.zip = event;
    } else {
      this.supplier[type] = event;
    }
  }

  handleAddAnother(type: string) {
    if (type === 'email' && this.supplier.emails.length < 5) {
      const isPrimary = !this.supplier.emails.filter(({ isPrimary }) => isPrimary).length;

      this.supplier.emails.push({
        ...this.helperService.deepCopy(contact),
        isPrimary: isPrimary,
        contactType: { label: 'Email', value: 'email' },
      });
    } else if (type === 'phone' && this.supplier.phones.length < 5) {
      const isPrimary = !this.supplier.phones.filter(({ isPrimary }) => isPrimary).length;

      this.supplier.phones.push({
        ...this.helperService.deepCopy(contact),
        isPrimary: isPrimary,
        contactType: 'mobile',
      });
    }
  }

  handleFocus(name: string) {
    this.validate[name] = '';

    if (name === 'phone') {
      this.validate.phone = '';
    }
  }

  handleDeleteContact(type: string, index: number) {
    this.supplier[type].splice(index, 1);
    this.errors[type][index] = {};
    this.handleDisableContactPref();
  }

  handleMultiFocus(type: string, key: string, index: number, focus: boolean) {
    if (!focus) {
      this.handleDisableContactPref();
    }
  }

  handleDisableContactPref() {
    if (this.supplier.emails && this.supplier.emails.length) {
      for (let i = 0; i < this.supplier.emails.length; i++) {
        const email = this.supplier.emails[i];

        if (email.isActive && email.isPrimary && this.validationService.validateEmail(email.value)) {
          this.isEmailDisabled = false;
        }
      }

      if (this.isEmailDisabled) {
        this.contactOnEmail = false;
      }
    }

    if (this.supplier.phones && this.supplier.phones.length) {
      for (let i = 0; i < this.supplier.phones.length; i++) {
        const phone = this.supplier.phones[i];

        if (phone.isActive && phone.isPrimary && this.helperService.removePhoneFormatting(phone.value).length >= 10) {
          this.isPhoneDisabled = false;
        }
      }

      if (this.isPhoneDisabled) {
        this.contactOnPhone = false;
      }
    }
  }

  handleMultiChange(type: string, key: string, index: number, value: any) {
    this.supplier[type][index][key] = value;

    if (value && type === 'phones' && key === 'contactType') {
      if (value.value === 'landline') {
        this.supplier.phones[index].isPrimary = false;
      }

      if (!this.supplier.phones.filter(({ isPrimary }) => isPrimary).length) {
        for (let i = 0; i < this.supplier.phones.length; i++) {
          const { isActive, contactType } = this.supplier.phones[i];

          if (isActive && contactType && contactType.value === 'mobile') {
            this.supplier.phones[i].isPrimary = true;
            break;
          }
        }
      }
    } else if (key === 'isPrimary') {
      this.supplier[type].forEach((contact: any, i: number) => {
        if (index !== i) {
          this.supplier[type][i].isPrimary = false;
        }
      });
    }
  }

  onAddressCityClear() {
    this.addressCityResults = [];
    this.supplier.wareHouseAddress.city = null;
  }

  onAddressCitySelect(event: any) {
    this.supplier.wareHouseAddress.city = event.city;
    this.supplier.wareHouseAddress.state = event.state;
    this.supplier.wareHouseAddress.stateCode = event.stateCode;
    this.supplier.wareHouseAddress.country = event.country;
  }

  renderCityName(city: string, stateCode: string) {
    if (city && stateCode) {
      return `${city}, ${stateCode}`;
    }

    return '';
  }

  zipChange(event: any, type: string) {
    if (!event) {
      return;
    }

    this.addressCities = this.allCities;
    this.bAddressCities = this.allCities;

    if (type === 'wareHouseAddress') {
      this.supplier.wareHouseAddress.zip = this.validationService.formatZip(event);
    } else {
      this.supplier.billingAddress.zip = this.validationService.formatZip(event);
    }

    const formattedZip = this.helperService.removeSpaceFromString(event).toUpperCase();

    this.httpService.getZip(formattedZip).then(
      (res) => {
        if (res) {
          this.supplier[type].city = res.city;
          this.supplier[type].state = res.state;
          this.supplier[type].stateCode = res.stateCode;
          this.supplier[type].country = res.country;

          if (type === 'wareHouseAddress') {
            this.isZipCode1Valid = true;
          }

          if (type === 'billingAddress') {
            this.isZipCode2Valid = true;
          }
        } else {
          if (type === 'wareHouseAddress') {
            this.supplier[type].city = null;
            this.supplier[type].state = null;
            this.isZipCode1Valid = false;
            this.validate.zip = 'Zip / Postal code is invalid';
          }

          if (type === 'billingAddress') {
            this.supplier[type].city = null;
            this.supplier[type].state = null;
            this.isZipCode2Valid = false;
            this.validate.zip2 = 'Zip / Postal code is invalid';
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  addressCitySearch(event: string) {
    const query = { city: this.helperService.trimString(event) };
    if (query) {
      this.httpService.citySearch(query).then(
        (cities) => {
          this.addressCityResults = cities;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  onBaddressCityClear() {
    this.bAddressCityResults = [];
    this.supplier.billingAddress.city = null;
  }

  bAddressCitySearch(event: any) {
    const query = { city: this.helperService.trimString(event) };

    if (query) {
      this.httpService.citySearch(query).then(
        (cities) => {
          this.bAddressCityResults = cities;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  onBaddressCitySelect(event: any) {
    this.supplier.billingAddress.city = event.city;
    this.supplier.billingAddress.state = event.state;
    this.supplier.billingAddress.stateCode = event.stateCode;
    this.supplier.billingAddress.country = event.country;
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.addCustomerForm.nativeElement.scrollTop = this.addCustomerForm.nativeElement.scrollHeight;
      } catch (err) {}
    }, 100);
  }

  /** Show tags suggestions in the dropdown */
  onTagFocus() {
    this.scrollToBottom();
  }

  onTagSelect(tag: any) {
    this.supplier.tags.push(tag);
  }

  onTagDelete(tags: any[]) {
    this.supplier.tags = tags;
  }

  onTagCreate(tag: any) {
    this.supplierTags = [...this.supplierTags, tag];
  }

  validation(): Boolean {
    let isFormValid = true;

    this.validate = {};
    this.errors = {
      emails: {},
      phones: {},
    };

    if (this.supplier.emails && this.supplier.emails.length) {
      const emails = [];
      this.supplier.emails.forEach((email: any, index: number) => {
        this.errors.emails[index] = {};

        if (emails.includes(email.value)) {
          this.errors.emails[index].value = `Add a unique email`;
          isFormValid = false;
        }

        if (email.value) {
          if (email.value && !this.validationService.validateEmail(email.value)) {
            this.errors.emails[index].value = 'Email is not valid';
            isFormValid = false;
          }

          emails.push(email.value);
        }
      });
    }
    if (this.supplier.phones && this.supplier.phones.length) {
      const phones = [];

      this.supplier.phones.forEach((phone: any, index: number) => {
        this.errors.phones[index] = {};
        phone.value = this.helperService.removePhoneFormatting(phone.value);

        if (phones.includes(phone.value)) {
          this.errors.phones[index].value = `Add a unique number`;
          isFormValid = false;
        }

        if (phone.value) {
          if ((phone.value || '').length < 10) {
            this.errors.phones[index].value = `Phone is not valid`;
            isFormValid = false;
          }

          phones.push(phone.value);
        }
      });
    }
    if (!this.isValidUrl) {
      this.validate.url = messages.inValidURL;
    }
    this.supplier.supplierName = this.supplier.supplierName?.trim()
    if (!this.supplier.supplierName) {
      this.validate.supplierName = 'Supplier name is required';
    }

    if (!this.supplier.name) {
      this.validate.name = 'Display name is required';
    }

    if (!this.isZipCode1Valid) {
      this.validate.zip = 'Zip / Postal code is invalid';
    }

    if (!this.isZipCode2Valid) {
      this.validate.zip2 = 'Zip / Postal code is invalid';
    }

    const isValid = isFormValid && this.isZipCode1Valid && this.isZipCode2Valid && this.supplier.name && this.supplier.supplierName && this.isValidUrl;
    return isValid;
  }

  handleSubmit() {
    if (!this.validation()) {
      return;
    }

    if (this.isProcessing) {
      return;
    }

    if(this.isSubletSupplierType) {
      this.supplier.type = {
        label: 'Sublet',
        name: 'Sublet',
        value: 'sublet',
        icon: 'far fa-store',
        placeholder: 'Sublet',
      };
    }
    if(this.isSubletSupplierType && !this.selectedSupplierName) {
      this.openConfirmationDialog();
    } else {
      if (this.supplierId) {
        this.handleUpdateSupplier();
      } else {
        this.handleCreateSupplier();
      }
    }
  }

  /** check for uniqueness on blur of name, email, phone */
  handleBlur(name: string) {
    let value = this.supplier[name];
    // this.focus[name] = false;
    if (name === 'url') {
      if (value) {
        const isValid = this.validationService.validateURLWebsite(value);
        if (!isValid) {
          this.isValidUrl = false;
          this.validate[name] = messages.inValidURL;
        } else if (isValid) {
          this.isValidUrl = true;
          this.validate[name] = '';
        }
        this.isSupplierDataValid = isValid;
        return isValid;
      }
      return false;
    }

    if (!value) {
      this.validate[name] = messages.inValidURL;
    }
  }

  formatSupplierData(data: any) {
    const supplier = { ...data };
    supplier.type = supplier.type.value;
    return supplier;
  }

  mapSupplierContactTypes() {
    this.supplier.emails && this.supplier.emails.map((x) => (x.contactType = x.contactType.value ? x.contactType.value : x.contactType));
    this.supplier.phones && this.supplier.phones.map((x) => (x.contactType = x.contactType.value ? x.contactType.value : x.contactType));
  }

  handleCreateSupplier() {
    this.isProcessing = true;
    this.mapSupplierContactTypes();
    this.httpService.createSupplier(this.formatSupplierData(this.supplier)).then(
      (supplier: any) => {
        if (supplier) {
          this.isProcessing = false;
          this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: supplier }));
          this.dynamicDialogRef.close();
          this.helperService.showToaster('success', 'Supplier created');
        }
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleUpdateSupplier() {
    this.isProcessing = true;
    this.mapSupplierContactTypes();
    this.httpService.updateSupplier(this.formatSupplierData(this.supplier)).then(
      (supplier: any) => {
        if (supplier) {
          this.isProcessing = false;
          this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: this.supplier.name }));
          this.dynamicDialogRef.close();
          this.helperService.showToaster('success', 'Supplier updated');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err.messages);
      }
    );
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getQboSupplierList() {
    this.httpService.getQBOSupplierList().then((res) => {
      if (res && res?.length) {
        this.qboSupplierList = res.map((item) => {
          return {
            ...item,
            label: item.name,
            value: item._id,
            name: item.name,
            _id: item._id,
          };
        });
        this.qboSupplierList = sortBy(this.qboSupplierList, 'supplierName');
      }
    });
  }

  getSupplierNames(): string[] {
    let supplierNames: string[];
    if (this.internalSuppliersResults) {
      supplierNames = this.internalSuppliersResults.map((supplier) => supplier);
    } else {
      supplierNames = this.qboSupplierList.map((supplier) => supplier);
    }
    // const sortedSupplierNames = supplierNames.sort((a, b) => a.localeCompare(b));
    return supplierNames;
  }

  selectSupplierRef($event) {
    this.selectedSupplierName = $event.name;
    this.supplier.internalSupplierReference = $event;
    this.formatInternalSupplierRefData();
  }

  formatInternalSupplierRefData() {
    if (this.isSubletSupplierType) {
      this.supplier.quickbooksCompatibility = {
        qboId: this.supplier?.internalSupplierReference?.quickbooksCompatibility?.qboId ? this.supplier?.internalSupplierReference?.quickbooksCompatibility?.qboId : null,
        internalId: this.supplier?.internalSupplierReference?._id,
        qboName: this.supplier?.internalSupplierReference?.name,
      };
    }
  }

  onInternalSupplierSearch(query: string = '') {
    const regex = new RegExp(query, 'i');
    this.internalSuppliersResults = this.qboSupplierList.filter((item) => regex.test(item.label));
    this.internalSuppliersResults = sortBy(this.internalSuppliersResults, 'supplierName');
  }

  onInternalSupplierClear() {
    this.selectedSupplierName = '';
    this.internalSuppliersResults = [...this.qboSupplierList];
  }

  showSuggestions(type?: string) {
    this.focus[type] = true;
  }

  createNewSupplier() {
    try {
      this.httpService
        .addNewQBOSupplier(this.supplier._id)
        .then((res) => {
          if (res) {
            this.dataService.sendData(this.dataService.typePassData('supplier-list', { data: res.name }));
            this.helperService.showToaster('success', 'QBO Supplier Added');
          }
        })
        .catch((err) => {
          this.helperService.showToaster('error', err.Message);
        });
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  openConfirmationDialog() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog sublet-supplier-customized-confirmation',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
        isHTML: true,
        styleClassHeading: 'font-18 font-700',
        styleClassCloseIcon: 'font-24 font-400 font-gray',
        title: `Internal supplier not selected`,
        message: `
        <span>
          <p>I understand that this will create a new supplier in QBO and this action cannot be reversed.</p>
        </span>`,
        button: {
          success: {
            title: 'Confirm',
            styleClass: 'btn-primary',
          },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        if (this.supplierId) {
          this.handleUpdateSupplier();
        } else {
          this.handleCreateSupplier();
        }
      }
      onClose.unsubscribe();
    });
  }
}
